<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.875 5.25V19.25L7 15.75L14 19.25L20.125 15.75V1.75L14 5.25L7 1.75L0.875 5.25Z"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 1.75V15.75"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 5.25V19.25"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconMap",
  props: {
    color: String
  }
};
</script>

<style></style>
